import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getCustomerNotificationSettings,
  getCustomerNotificationsSettings,
  resetCustomerNotificationsSettings,
  updateCustomerNotificationSettings,
  updateCustomerNotificationsSettings,
} from "controller/api";
import {
  ApiErrorType,
  UpdateCustomerNotificationInput,
  UpdateCustomerNotificationsSettingsInput,
} from "shared";
import { sentryLogger } from "utilz";

//======================== NEW ===============================//
export const useGetCustomerNotificationsSettings = (customerId?: string) => {
  return useQuery({
    queryKey: ["v2", "customers", "notifications", customerId],
    queryFn: () => getCustomerNotificationsSettings(customerId || ""),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "customer",
        level: "error",
        functionName: "getCustomerNotificationsSetttings",
      });
    },
    enabled: !!customerId,
  });
};

export const useUpdateCustomerNotificationsSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (value: UpdateCustomerNotificationsSettingsInput) =>
      updateCustomerNotificationsSettings(value),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries([
          "v2",
          "customers",
          "notifications",
          variables.customerId,
        ]);
      },
      onError(error: ApiErrorType) {
        sentryLogger({
          error: error,
          workflow: "customer",
          level: "error",
          functionName: "updateCustomerNotificationsSettings",
        });
      },
    }
  );
};

export const useResetCustomerNotificationsSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (customerId: string) => resetCustomerNotificationsSettings(customerId),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries([
          "v2",
          "customers",
          "notifications",
          variables,
        ]);
      },
      onError(error: ApiErrorType) {
        sentryLogger({
          error: error,
          workflow: "customer",
          level: "error",
          functionName: "resetCustomerNotificationsSettings",
        });
      },
    }
  );
};
//======================== NEW ===============================//

// ======================== OLD ==============================//
export const useGetCustomerNotificationSettings = (customerId: string) => {
  return useQuery({
    queryKey: ["customer_notification_settings", customerId],
    queryFn: () => getCustomerNotificationSettings(customerId),
    onError: (error) => console.log(error),
  });
};

export const useUpdateCustomerNotificationSettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (value: UpdateCustomerNotificationInput) =>
      updateCustomerNotificationSettings(value),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries([
          "customer_notification_settings",
          variables.customerId,
        ]);
      },
    }
  );
};
// ======================== OLD ==============================//
